import {inject, Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {AppRequests} from '../../const';
import {map, take} from 'rxjs';

export interface FeedbackSubject {
  id: number;
  subject: string;
}

export interface FeedbackBackendSubject extends FeedbackSubject {
  recipientEmail: string;
  recipientName: string;
}

export interface FeedbackDto {
  body: string | null;
  phone: string;
  subjectId: number | null;
  saveComplaint: false,
  referrerURL: string,
  complaintSubject: null,
  userKey: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class FeedbackService {

  _http = inject(HttpService);

  fetchFeedbackSubjects() {
    return this._http.request(AppRequests['getFeedbackSubjects'])
      .pipe(
        take(1),
        map((subjects: FeedbackBackendSubject[]) =>
          subjects.map((s: FeedbackSubject) => {
            if (s.id === 9) {
              return {
                value: s.id,
                display: 'Предложить идею',
              };
            } else {
              return {
                value: s.id,
                display: s.subject,
              };
            }
          })
        )
      )
  }

  sendFeedback(feedback: FeedbackDto) {
    return this._http.request(AppRequests['postFeedbackHmac'])
  }


}
